import { z } from 'zod';
import { PaginationQuerySchema } from './pagination.js';

const HostNameSchema = z.string().trim().min(1).max(200);
const HostSubtitleSchema = z.string().trim().max(200);
const HostDescriptionSchema = z.string().trim().max(500);

export const AdminHostQuerySchema = PaginationQuerySchema.extend({
  q: z.string().max(200).optional(),
});

export type AdminHostQuery = z.infer<typeof AdminHostQuerySchema>;

export const AdminCreateHostSchema = z.object({
  firstName: HostNameSchema,
  lastName: HostNameSchema,
  subtitle: HostSubtitleSchema.nullable().optional(),
  description: HostDescriptionSchema.nullable().optional(),
  avatarAssetId: z.string().uuid().nullable().optional(),
});

export type AdminCreateHostDto = z.infer<typeof AdminCreateHostSchema>;

export const AdminUpdateHostSchema = z.object({
  firstName: HostNameSchema.optional(),
  lastName: HostNameSchema.optional(),
  subtitle: HostSubtitleSchema.nullable().optional(),
  description: HostDescriptionSchema.nullable().optional(),
  avatarAssetId: z.string().uuid().nullable().optional(),
});

export type AdminUpdateHostDto = z.infer<typeof AdminUpdateHostSchema>;

export const AdminClubHostExistingSelectionSchema = z.object({
  mode: z.literal('existing'),
  hostId: z.string().uuid(),
});

export const AdminClubHostCreateInputSchema = z.object({
  mode: z.literal('create'),
  firstName: HostNameSchema,
  lastName: HostNameSchema,
  subtitle: HostSubtitleSchema.nullable().optional(),
  description: HostDescriptionSchema.nullable().optional(),
  avatarAssetId: z.string().uuid().nullable().optional(),
});

export const AdminClubHostSlotInputSchema = z.union([
  AdminClubHostExistingSelectionSchema,
  AdminClubHostCreateInputSchema,
]);

export type AdminClubHostSlotInput = z.infer<typeof AdminClubHostSlotInputSchema>;

export const AdminHostSchema = z.object({
  id: z.string(),
  firstName: HostNameSchema,
  lastName: HostNameSchema,
  fullName: z.string(),
  shortName: z.string(),
  subtitle: z.string().nullable(),
  description: z.string().nullable(),
  avatarAssetId: z.string().uuid().nullable(),
  avatarUrl: z.string().nullable(),
  primaryClubCount: z.number().int().nonnegative(),
  secondaryClubCount: z.number().int().nonnegative(),
  totalClubCount: z.number().int().nonnegative(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type AdminHost = z.infer<typeof AdminHostSchema>;

export const AdminHostsResponseSchema = z.object({
  items: z.array(AdminHostSchema),
  nextCursor: z.string().optional(),
});

export type AdminHostsResponse = z.infer<typeof AdminHostsResponseSchema>;
